import clsx from 'clsx';
/** Layout ヘッダー用 className */
export const CLASS_NAME_HEADER = 'l-header';
export const CLASS_HEADER_Z_INDEX = clsx('z-[1010]');
